import type { TermKind } from "../rdf/types";

/** Shared color/label per RDF "kind", reused by the Explorer's badges/tree icons and the Visualizer's node styling. */
export const KIND_STYLE: Record<TermKind, { label: string; color: string; glyph: string }> = {
  Class: { label: "Class", color: "#eab308", glyph: "C" },
  ObjectProperty: { label: "Object Property", color: "#3b82f6", glyph: "→" },
  DatatypeProperty: { label: "Datatype Property", color: "#06b6d4", glyph: "=" },
  AnnotationProperty: { label: "Annotation Property", color: "#8b93a7", glyph: "@" },
  Property: { label: "Property", color: "#60a5fa", glyph: "P" },
  NodeShape: { label: "Node Shape", color: "#22c55e", glyph: "◆" },
  PropertyShape: { label: "Property Shape", color: "#4ade80", glyph: "◇" },
  Ontology: { label: "Ontology", color: "#f97316", glyph: "◎" },
  Datatype: { label: "Datatype", color: "#a855f7", glyph: "#" },
  Individual: { label: "Individual", color: "#ec4899", glyph: "•" },
};
